import React from 'react';

import './loader.scss';

interface LoaderProps {
  children: React.ReactNode;
  isLoadingAPIs?: boolean[];
  hideChildren?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ children, hideChildren, isLoadingAPIs = [] }) => {
  const isLoading = Boolean(isLoadingAPIs.filter(Boolean).length);

  return (
    <React.Fragment>
      {hideChildren && isLoading ? null : children}
      {isLoading && (
        <div className="rc-loader">
          <img
            src="https://www.siteground.com/static/en/img/recap2023/web_loader_shape_morpher.png"
            width={38}
            height={38}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default Loader;
